import StyledLink from '../StyledLink'
import {
  MEMBERS,
  SPACES
} from '../routes'

interface Props {
  children: React.ReactNode
  spaceId: string
}

const LinkToSpaceMembers = ({
  children,
  spaceId
}: Props) =>
  <StyledLink
    to={`/${SPACES}/${spaceId}/${MEMBERS}`}
  >
    {children}
  </StyledLink>

export default LinkToSpaceMembers
